import { render, staticRenderFns } from "./BulkReassign.vue?vue&type=template&id=824ee72e&"
import script from "./BulkReassign.vue?vue&type=script&lang=js&"
export * from "./BulkReassign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports